// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__lkYQp","active":"RoomScene_active__1vwhc"};